import { Flex } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { VotacaoPerguntaDto } from "core/features/assembleia/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import { AiOutlineCheck, AiOutlineClockCircle } from "react-icons/ai";
import ShowMoreText from "react-show-more-text";

interface ListaPerguntasProps {
  selectedPergunta: VotacaoPerguntaDto | undefined;
  isLoading: boolean;
  perguntas: VotacaoPerguntaDto[] | undefined;
  onSelect: (pergunta: VotacaoPerguntaDto | undefined) => any;
  onUnselect?: () => any;
}

function ListaPerguntas({
  selectedPergunta,
  isLoading,
  perguntas,
  onSelect,
  onUnselect,
}: ListaPerguntasProps) {
  if (isLoading) {
    return (
      <Flex flexDir="column" gridGap={4}>
        <Skeleton w="100%" rounded={6} h="60px" />
        <Skeleton w="100%" rounded={6} h="60px" />
        <Skeleton w="100%" rounded={6} h="60px" />
        <Skeleton w="100%" rounded={6} h="60px" />
      </Flex>
    );
  }
  return (
    <Flex flexDir="column" gridGap={4}>
      {perguntas?.map((pergunta, index) => {
        const selected =
          selectedPergunta && selectedPergunta.id === pergunta.id;
        return (
          <Flex
            bg="white"
            rounded={6}
            shadow="sm"
            py={4}
            px={2}
            alignItems="center"
            minH="60px"
            key={pergunta.id}
            cursor="pointer"
            onClick={(ev) => {
              if ((ev.target as any).className === "show-more-anchor") {
                return;
              }

              if (selected) {
                onUnselect?.();
              } else {
                onSelect(pergunta);
              }
            }}
            borderWidth={2}
            borderColor={selected ? colors.primary : "transparent"}
            gridGap={2}
          >
            <Flex w="24px" h="24px">
              {(pergunta.dataEncerramento &&
                moment(pergunta.dataEncerramento).isBefore(moment())) ||
              !pergunta.ativo ? (
                <AiOutlineCheck color={colors.green500} fontSize={18} />
              ) : (
                <AiOutlineClockCircle color={colors.yellow} fontSize={18} />
              )}
            </Flex>
            <ShowMoreText
              more="Ver mais"
              less="Ver menos"
              lines={3}
              truncatedEndingComponent={"..."}
              className="show-more-text-perguntas"
              anchorClass="show-more-anchor"
            >
              {pergunta.ordem + 1 || index + 1}. {pergunta.titulo}
            </ShowMoreText>
          </Flex>
        );
      })}
    </Flex>
  );
}

export default ListaPerguntas;
